export const profileOfConcernTooltip =
  'Use the Person of Concern profile to store information like instructions for care, emergency contacts, and medications. ' +
  'An automatically generated report can share this information with others'

export const careJourneyTooltip =
  'Care Journey provides a list of posts and queries tailored to your situation. ' +
  'Notes from team members and assigned-to-do items also appear here'

export const actionsPlanTooltip = 'This section is under construction.'

export const addNoteTooltip = 'Create a Note to yourself or share with others.'

export const searchTooltip = 'Find posts and articles containing words you enter'

export const familyLearnLibraryTooltipHeader =
  'Use the Learn Library to find in depth articles and you can limit selection to guide what is most helpful at each phase of memory loss'

export const queriesTooltip =
  'Answer short queries to help us provide the most meaningful and effective help along your caregiving journey'

// -------------Trainee------------------

export const traineeProfileTooltip =
  'Use the Trainee profile to store information like your address, telephone information, ' +
  'your role and experience, and emergency contacts.  ' +
  'An automatically generated report can share this information with other members of your care team or employers.'

export const traineeJourneyTooltip =
  'Training Journey provides a list of posts and lessons tailored to your situation. ' +
  'Notes to yourself about lessons and questions to explore later also appear here'

export const traineeLearnLibraryTooltip =
  'Use the Learn Library to read articles and use queries to guide what is most helpful at each phase of memory loss'

export const traineeProgressTooltip =
  'Progress shows a list of your assignments and your scores on tests you have completed.'

export const traineeLearnLibraryHeaderTooltip =
  'Use the Learn Library to find in depth articles and you can limit selection to guide what is most helpful at each phase of memory loss'
